import React, { useEffect, useState, useContext } from 'react'
import UserContext from 'contexts/UserContext'
import { getListBeneficary } from '../requests/benificary'
import ModalBeneficiary from './beneficiaireContainer/modalBeneficiary'
import ModalAddBeneficiary from './beneficiaireContainer/modalAddBeneficiary'
import btnDeleted from '../assets/iconDelete.svg'
import { useLocation } from 'react-router-dom'

import ModalDeleteBeneficiary from './beneficiaireContainer/modalDeleteBeneficiary'

import BtnUpdate from '../assets/iconUpdateBenef.svg'
import BtnService from '../assets/iconServiceEasy.svg'
import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'
import Avatar from 'components/avatar'
import UpdateModalBeneficiary from './beneficiaireContainer/updateModalBeneficiary'
import ModalHomeBeneficiary from './homeContainers/modalHomeBeneficiary'

import RechargeContext from 'contexts/rechargeContext'

type Beneficiary = {
  bankCode?: string
  bankName?: string
  identifiantCardNumber?: string
  confirmerNumeroCompte?: string
  accountNumber?: string
  personalInfo: {
    gender: string
    firstName: string
    lastName: string
    phone: {
      prefix: string
      number: string
    }
  }

  relationship: string
  language: string
  avatar: number
  userId: string
  _id: string
}



const Beneficiary = () => {
  const location = useLocation()
  const currenPath = location.pathname
  const { setTransferDataBeneficiary, TransferData, setTransferData } = useContext(transferBeneficiaryContext)

  const { recharges, setRecharges } = useContext(RechargeContext)

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [isModalOpenDelete, setIsModalOpenDelete] = useState<boolean>(false)
  const [beneficiaryData, setBeneficiaryData] = useState<Beneficiary[]>([])
  const [benefUpdate, setBenefUpdate] = useState<Beneficiary | undefined>()

  const { user } = useContext(UserContext)
  const [loading, setLoading] = useState(false)
  const [Beneficaire, setBeneficaire] = useState<Beneficiary>()
  const [isUpdateBenef, setIsUpdateBenef] = useState<boolean>(false)
  const [isOpenModal, setIsopenModal] = useState(false)

  const [indexBeneficiaryDeleted, setIndexBeneficiaryDeleted] = useState(-1)

  const [isAdded, setIsAdded] = useState(false)
  const COUNTRY_MAP: Record<string, string> = {
  '216': 'TND',
  '221': 'XOF',
  '212': 'MAD',
  '92': 'PKR',
  '880': 'BDT',
  '90': 'TRY',
  '234' : 'NGN',
  '254': 'KES',
  '63': 'PHP'

}
const formaPrefix = (prefix?: string)=>{
  if(!prefix) return ''
  return prefix.startsWith('+')? prefix : `+${prefix}`
}
useEffect(()=>{
  if(currenPath==='/beneficiary')
    setTransferData(null)
},[currenPath, setTransferData]) 

  // const openModalBeneficiaryPerson = (person: any) => {
  //   setIsopenModal(true)
  // }
  const closeModalBeneficiaryPerson = () => {
    setIsopenModal(false)
  }

  const openModal = () => {
    setIsModalOpen(true)
  }
  const closeModal = () => {
    setIsModalOpen(false)
  }

  const openModalDelete = (id: any) => {
    setIsModalOpenDelete(true)
    setIndexBeneficiaryDeleted(id)
  }
  const closeModalDelete = () => {
    setIsModalOpenDelete(false)
  }

  const openModalUpdate = (item: any) => {
    setIsUpdateBenef(true)
    setBenefUpdate(item)
  }
  const closeModalUpdate = () => {
    setIsUpdateBenef(false)
  }
  useEffect(() => {
    openModalUpdate
  }, [benefUpdate])

  useEffect(() => {
    async function fetchData() {
      const id = user?.user?._id
      const token = user?.token?.accessToken
      try {
        const response = await getListBeneficary(id, token)
        if (response?.success === true) {
          setBeneficiaryData(response?.beneficiaries)
          setTransferDataBeneficiary(response?.beneficiaries)
          setLoading(true)
        }
      } catch (error) {
        console.error('Error fetching beneficiary data:', error)
      }
    }
    if (user) {
      fetchData()
    }
  }, [user, isAdded, isUpdateBenef])
  return (
    <div>
      <div className={` flex items-center lg:flex-col justify-between w-full mt-3 sm:gap-3`} >
        <h4 className=" sm:text-[22px] font-bold  text-[#0A0A0A] text-[30px] ">Mes Bénéficiaires</h4>
        <button
          className="flex items-center justify-center text-white font-semibold text-[14px] bg-[#5754E5] w-[220px] h-[40px] rounded-xl "
          onClick={openModal}
        >
          <span className="text-[22px]  pr-2 font-normal"> + </span> Ajouter un bénéficiaire
        </button>
      </div>
      {/* <div className={` ${(isModalOpen || isOpenModal || isUpdateBenef) && 'fixed'} flex  flex-wrap justify-center mt-6 gap-5 min-h-0`}> */}
      <div className={` flex  flex-wrap justify-center mt-6 gap-5 min-h-0`}>

        {beneficiaryData.map((item, index) => (
          <div key={index} className="">
            <div
              className={`w-[210px] h-[330px]  group sm:w-[250px] p-2 flex flex-col items-center justify-center  
                rounded-xl  hover:shadow-[0_6px_20px_rgba(87,84,229,0.1)]  hover:border hover:border-[#D1D1FF] `}
            >
              <Avatar avatar={item.avatar}/>

              <div
                className={` text-[#0A0A0A] text-[18px] mt-3`}
                title={`${item?.personalInfo?.firstName} ${item?.personalInfo?.lastName}`}
              >
                {`${item?.personalInfo?.lastName}`.length > 8
                  ? `${item?.personalInfo?.firstName?.slice(0, 15)}...`
                  : `${item?.personalInfo?.firstName} ${item?.personalInfo?.lastName}`}
              </div>

              <div className="text-[#B4B4B4] text-[12px]">
                {formaPrefix(item?.personalInfo?.phone.prefix)}
                {' '}
                {item?.personalInfo?.phone.number}
              </div>

              <div className=" items-center gap-1 mt-4 hidden group-hover:flex">
                <img
                  className=" hover:cursor-pointer "
                  onClick={() => {
                    openModalDelete(item), setIndexBeneficiaryDeleted(index)
                  }}
                  src={btnDeleted}
                />

                <button
                  className=" rounded-lg flex items-center justify-center cursor-pointer"
                  onClick={() => {
                    openModalUpdate(item)
                  }}
                  aria-label="Modifier Bénéficiaire"
                >
                  <img src={BtnUpdate} alt="" />
                </button>

                <img
                  className=" hover:cursor-pointer "
                  onClick={() => {
                    setBeneficaire(item)
                    setRecharges({
                      ...recharges,
                      phoneNumber: item.personalInfo.phone.number,
                      prefix: `${'+'}${item.personalInfo.phone.prefix}`,
                      isOperateur:'',
                      labelOperateur:''
                    })

                    setTransferData({
                      ...TransferData,
                      BeneficiaryName: `${item?.personalInfo?.firstName} ${item?.personalInfo?.lastName}`,
                      idBeneficiary: item?._id,
                      numBankBeneficiary: item?.accountNumber,
                      cinBeneficiary: item?.identifiantCardNumber,
                      phoneNumberBeneficiary: `${item?.personalInfo?.phone.prefix} ${item?.personalInfo?.phone.number} `,
                      valuePays: COUNTRY_MAP[item?.personalInfo?.phone.prefix],
                      currentPath: currenPath,
                    })
                    setIsopenModal(true)
                  }}
                  src={BtnService}
                />
              </div>

            </div>

           

            <ModalDeleteBeneficiary
              isOpen={index === indexBeneficiaryDeleted}
              closeModal={closeModalDelete}
              idBnf={item?._id}
              isModalOpenDelete={isModalOpenDelete}
              setBeneficiaryData={setBeneficiaryData}
              isAdded={isAdded}
              setIsAdded={() => setIsAdded(!isAdded)}
            />
          </div>
        ))}
      </div>

      {!isModalOpen && (
        <div className="bg-transparent inset-0 z-50 w-full h-screen">
          <UpdateModalBeneficiary
            isOpen={isUpdateBenef}
            closeModal={closeModalUpdate}
            benefUpdate={benefUpdate}
            setBenefUpdate={setBenefUpdate}
            setBeneficiaryData={setBeneficiaryData}
          />
        </div>
      )}

      {isOpenModal && (
        <div className="inset-0 z-50 w-full ">
          <ModalHomeBeneficiary
            nom={`${Beneficaire?.personalInfo?.gender === 'male' ? 'M.' : 'Mme'} ${Beneficaire?.personalInfo?.firstName} ${Beneficaire?.personalInfo?.lastName}`}
            num={Beneficaire?.personalInfo?.phone.number}
            photo={Beneficaire?.avatar ? Beneficaire.avatar : Beneficaire?.personalInfo?.gender}
            index={Beneficaire?._id}
            indexBeneficiary={Beneficaire?._id}
            isOpen={isOpenModal}
            closeModal={closeModalBeneficiaryPerson}
            person={Beneficaire}
            prefix={Beneficaire?.personalInfo?.phone?.prefix ?? ''}
          />
        </div>
      )}

      <ModalBeneficiary isOpen={isModalOpen} closeModal={closeModal}>
        <ModalAddBeneficiary
          closeModal={closeModal}
          setIsAdded={() => setIsAdded(!isAdded)}
      
        />
      </ModalBeneficiary>
    </div>
  )
}
export default Beneficiary
